import * as React from 'react';
import { Avatar, Table, Popconfirm, Tooltip, Button } from 'antd';
import { Member } from 'src/store';
import { Subscription, Observable } from 'rxjs';
import * as firebase from 'firebase/app';
import { ColumnProps } from 'antd/lib/table';
import { DisplayDate } from 'src/components';

const ButtonGroup = Button.Group;

interface Props {
    merchantId: string;
}

interface S {
    data: Member[];
    loading?: boolean;
    currentPage: number;
}

class MemberList extends React.Component<Props, S> {
    subscription: Subscription;
    columns: ColumnProps<Member>[];
    queryRef: firebase.firestore.Query;
    pageSize: number;
    constructor(props: Props) {
        super(props);

        this.subscription = new Subscription();
        const { merchantId } = this.props;
        this.pageSize = 10;
        this.state = { data: [], loading: false, currentPage: 1 };
        this.queryRef = firebase.firestore()
            .doc(`merchants/${merchantId}`)
            .collection('members')
            .orderBy('createdOn', 'desc');
    }

    componentDidMount() {
        this.handlePageChange(1);
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    handlePageChange = (page: number) => {
        const paginatedRef = this.queryRef;
        this.setState({ loading: true });
        // if (page > 1) {
        //     paginatedRef = this.queryRef.endAt(page);
        // }

        const members$ = new Observable<firebase.firestore.QuerySnapshot>(observer => {
            return paginatedRef.onSnapshot(sn => observer.next(sn));
        });

        this.subscription = members$.subscribe(sn => {
            if (!sn.empty) {
                const data = sn.docs.map(d => ({ ...d.data(), id: d.id } as Member));
                this.setState({ data, loading: false, currentPage: page });
            } else {
                this.setState({ data: [], loading: false, currentPage: page });
            }
        });
    }

    getDataSource = () => {
        const { data, loading, currentPage } = this.state;
        const page = loading ? 1 : currentPage;
        const ds = !loading ?
            data.map((obj, i) => ({
                // no: ((page - 1) * this.pageSize) + (i + 1),
                no: i + 1,
                key: obj.id,
                ...obj,
            })) : [];

        return {
            ds,
            page,
        };
    }

    handleDelete = async (memberId: string) => {
        const { merchantId } = this.props;

        const firestore = firebase.firestore();

        const memberRef = firestore.doc(`merchants/${merchantId}`)
            .collection('members')
            .doc(memberId);

        const notificationsQuery = firestore.doc(`members/${memberId}`)
            .collection('notifications').where('merchantId', '==', merchantId);

        const campaignsQuery = firestore.doc(`members/${memberId}/merchants/${merchantId}`)
            .collection('campaigns');

        const pointsQuery = firestore.doc(`members/${memberId}/merchants/${merchantId}`)
            .collection('points');

        const rewardsQuery = firestore.doc(`members/${memberId}`)
            .collection('rewards');

        const merchantRef = firestore.doc(`members/${memberId}`)
            .collection('merchants')
            .doc(merchantId);

        await firestore.runTransaction(async tx => {
            const notificationSnapshot = await notificationsQuery.get();
            const campaignSnapshot = await campaignsQuery.get();
            const pointsSnapshot = await pointsQuery.get();
            const rewardSnapshot = await rewardsQuery.get();
            tx.delete(memberRef);
            tx.delete(merchantRef);

            campaignSnapshot.forEach(doc => {
                tx.delete(doc.ref);
            })
            pointsSnapshot.forEach(doc => {
                tx.delete(doc.ref);
            })
            notificationSnapshot.forEach(doc => {
                tx.delete(doc.ref);
            });
            rewardSnapshot.forEach(doc => {
                tx.delete(doc.ref);
            });
        });
    }
    render() {
        const { ds } = this.getDataSource();
        const { loading } = this.state;
        this.columns = [{
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            width: "5%",
            render: (text: string, record: Member, index: number) => {
                return <span>{record.no}</span>;
            }
        },
        {
            title: 'Image',
            dataIndex: 'photo',
            key: 'photo',
            width: "10%",
            // tslint:disable-next-line:no-any
            render: (text: string, record: Member) => (
                <span>
                    <Avatar
                        src={record.photo}
                        className="img-circle"
                    />
                </span>
            )
        },
        {
            title: 'Display Name',
            dataIndex: 'displayName',
            key: 'displayName',
            width: '20%',
        },
        // {
        //     title: 'Email',
        //     dataIndex: 'email',
        //     key: 'email',
        //     width: '20%',
        // },
        // {
        //     title: 'Phone',
        //     dataIndex: 'phoneNumber',
        //     key: 'phoneNumber',
        //     width: '15%',
        // },
        {
            title: 'Created At',
            // dataIndex: 'creat',
            width: '15%',
            // tslint:disable-next-line:no-any
            render: (text: string, record: any) => {
                return <DisplayDate dateTime={record.createdOn.toDate()} />
            }
        },
        // {
        //     title: 'Signed In',
        //     dataIndex: 'creat',
        //     key: 'loginUserName',
        //     width: '15%',
        //     // tslint:disable-next-line:no-any
        //     render: (text: string, record: any) => {
        //         return <DisplayDate dateTime={record.metadata.lastSignInTime} />
        //     }
        // }
        {
            title: 'Action',
            key: 'action',
            align: 'center',
            width: '20%',
            render: (text: string, record: Member) => {
                return (
                    <ButtonGroup>
                        <Popconfirm
                            title="Are you sure you want to delete member?"
                            // tslint:disable-next-line:jsx-no-lambda
                            onConfirm={() => { this.handleDelete(record.id); }}
                            // onCancel={cancel} 
                            okText="Yes"
                            cancelText="No"
                        >
                            <Tooltip placement="top" title="Click to Delete Member">
                                <Button icon="delete">Delete</Button>
                            </Tooltip>
                        </Popconfirm>
                    </ButtonGroup>
                );
            }

        }
        ];
        return (
            <Table
                loading={loading}
                columns={this.columns}
                dataSource={ds}
                // onRow={this.handleOnRow}
                pagination={{
                    // current: page || 0,
                    // pageSize: this.pageSize,
                    // total: ds.length || 0,
                    // onChange: this.handlePageChange,
                    showTotal: (total) => <span className="total-count">Total Count: {total}</span>
                }}
                size="middle"
                bordered={true}
            />
        );
    }
}

export default MemberList;



// WEBPACK FOOTER //
// ./src/merchants/forms/MemberList.tsx